import { Button } from "../ui/button";
import { AlertTriangle, Trash2 } from "lucide-react";

export default function LogsPanel({ logs, onClear }) {
  return (
    <div className="glass-card overflow-hidden">
      <div className="section-accent p-5 sm:p-6 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-amber-400" />
          <h2 className="font-heading text-lg font-semibold text-slate-100">Logs de Erro de Conexão</h2>
        </div>
        <Button size="sm" variant="outline" onClick={onClear} data-testid="admin-clear-logs-button"
          className="border-slate-700 text-slate-300 hover:bg-slate-800 h-8 text-xs">
          <Trash2 className="w-3.5 h-3.5 mr-1" /> Limpar logs
        </Button>
      </div>
      <div className="divide-y divide-white/[0.04] max-h-96 overflow-y-auto" data-testid="admin-logs-table">
        {logs.length === 0 ? (
          <p className="p-8 text-center text-sm text-slate-500">Nenhum erro registrado. A plataforma está saudável.</p>
        ) : (
          logs.map((l) => (
            <div key={l.id} className="px-5 py-3.5">
              <div className="flex items-center justify-between gap-2 mb-1">
                <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-300 border border-amber-500/30 uppercase tracking-wider">
                  {l.tipo}
                </span>
                <span className="text-[10px] text-slate-500 font-mono">{new Date(l.created_at).toLocaleString("pt-BR")}</span>
              </div>
              <p className="text-xs text-slate-400 leading-relaxed">{l.mensagem}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
